import React, { useEffect } from 'react';
import "../../App.css"
import ERetailFSAPage from './ERetailsFSAPage/ERetailFSAPage';
import User2 from './user2';
import User3 from './user3';
import EmissionBaseLine from '../Emission/EmissonBaseLine';
import StewardShip from '../StewardShip/StewardShip';
import ManualAdjustmentUser from '../manualAdjustment/user';
import CustomHierarchy from '../custHier/customHierarchy';
import User4 from './user4';
import { useParams } from 'react-router-dom';

const UserRoute = () => {
    const { id } = useParams();
    
    switch (id) {
        case 'formecomm':
            return <ERetailFSAPage />;
        case 'formsku':
            return <User2 />;
        case 'formmap':
            return <User3 />;
        case 'priceforecast':
            return <User4 />;
        case 'emission':
            return <EmissionBaseLine />;
        case 'sustainability':
            return <StewardShip />;
        case 'manualnum':
            return <ManualAdjustmentUser />;
        case 'custhier':
            return <CustomHierarchy />;
        default:
            return <></>;
    }
};

export default UserRoute;